import { render, staticRenderFns } from "./PchProviderPaymentList.vue?vue&type=template&id=0d9bb5ca&lang=pug&"
import script from "./PchProviderPaymentList.vue?vue&type=script&lang=js&"
export * from "./PchProviderPaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PchProviderPaymentList.vue"
export default component.exports